import React from 'react';
import { Row, Col, Button, Spinner } from 'reactstrap';
import { StyledButton } from './UI';
import './NavMenu.css';

const PageHeader = ({ name, isLoading = false, onClickHandler, isVisible = false, children = null }) => {

    return (
        <Row className="page-header">
            <Col sm={3} className="page-header-name">
                {name}
            </Col>
            <Col>
                {children}
            </Col>
            <Col sm={3} className="page-header-button">
                {isLoading &&
                    <Spinner
                        color="success"
                        size="sm"
                    />
                }
                {(onClickHandler && !isLoading && isVisible) && <StyledButton onClickHandler={onClickHandler}>Добавить</StyledButton>}
            </Col>
        </Row>
    );
};

export default PageHeader;
